<template>
  <span>
    <!-- {{notificaciones}} -->
    <v-snackbar
      app
      :style="{'margin-bottom': (i*135)+'px' }"
      v-for="(notificacion, i) in notificaciones"
      :key="i"
      :timeout="-1"
      transition="scale-transition"
      v-model="notificacion.visible"
    >
      <v-icon class="mr-3" color="#dfb750">mdi-phone-ring</v-icon><strong>Llamada de interfonía</strong>
      <br><br>
      {{ $t ('Aparcamiento') }}: <span class="destacar">{{notificacion.datos.origen.instalacion}}</span><br>
      {{ $t ('Aparato') }}: <span class="destacar">{{notificacion.datos.origen.descripcion_interfonia}}</span>
      <br><br>
      <v-btn class="mr-2" color="primary" @click="btnGestionarClick (notificacion)"><v-icon left>mdi-face-agent</v-icon>{{ $t ('Gestionar') }}</v-btn>
      <v-btn class="mr-2" color="yellow" text @click="notificaciones.splice (i, 1)">{{ $t ('Cerrar') }}</v-btn>
    </v-snackbar>
  </span>
</template>

<script>
import { DateTime } from "luxon";

export default {
  data() {
    return {
      manejadorNotificacionesInterfonia: null,
      manejadorTemporizador: null,
      notificaciones: []
    }
  },
  methods: {
    eliminarNotificacionesCaducadas () {
      let indice = this.notificaciones.length-1;
      while (indice >= 0) {
        if (DateTime.fromISO (this.notificaciones[indice].fecha_hora_local).diffNow ('seconds').seconds < -240)
          this.notificaciones.splice (indice, 1);
        indice--;
      }
    },
    procesarMensajeInterfonia (mensaje) {
      // --- notificacion de interfonia ---
      if (mensaje.contenido.tipo_mensaje == "notificacion_interfonia") {
        // llamada recibida:
        if (mensaje.contenido.tipo_evento_interfonia == 1) {
          if (!this.notificaciones.some ((e) => e.datos.origen.id_dispositivo == mensaje.contenido.origen.id_dispositivo)) {
            this.notificaciones.push ({
                                  visible: true,
                                  fecha_hora_local: DateTime.now().toISO(),
                                  datos: mensaje.contenido
                                });
            //menu.obtenerElementoRuta ('/panel/registroInterfonia').notificaciones++;
          }
        }  // llamada finalizada:
        else if (mensaje.contenido.tipo_evento_interfonia == 3) {
          let indice = this.notificaciones.length-1;
          while (indice >= 0) {
            if (this.notificaciones[indice].datos.origen.id_dispositivo == mensaje.contenido.destino.id_dispositivo)
              this.notificaciones.splice (indice, 1);
            indice--;
          }
        }
      }

      // --- llamada atendida ---
      if (mensaje.contenido.tipo_mensaje == "informar_llamada_atendida") {
        this.notificaciones.some ((notificacion, indice) => {
          if (notificacion.datos.id_registro_interfonia == mensaje.contenido.id_registro_interfonia) {
            this.notificaciones.splice (indice, 1);
            //menu.obtenerElementoRuta ('/panel/registroInterfonia').notificaciones--;
            return true;
          }
        });
      }
    },
    btnGestionarClick(notificacion) {
      this.$emit ('gestionar-notificacion', notificacion);
      this.$sagabroker.informarLlamadaAtendida (notificacion.datos.id_registro_interfonia);
    }
  },
  created () {
    this.manejadorNotificacionesInterfonia = this.$sagabroker.anadirEscuchadorTema ("central_interfonia/llamadas", this.procesarMensajeInterfonia);

    // temporizador para eliminar notificaciones caducadas...
    this.manejadorTemporizador = setInterval (this.eliminarNotificacionesCaducadas, 2000);
  },
  destroyed () {
    clearInterval (this.manejadorTemporizador);

    this.$sagabroker.eliminarEscuchadorTema (this.manejadorNotificacionesInterfonia);
  }
}
</script>

<style>

</style>